import React, {useState,useEffect} from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import Rightbar from './Rightbar';
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import { createPath, Link, useNavigate, useParams } from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Swal from "sweetalert2";
import {listArtworkByPayment,createVirtualBooth} from '../../Service';
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";
export default function CreateVirtualbooth(){ 
const params = useParams();


const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const [formErrors, setFormErrors] = useState({});
const [imageErrors, setImageErrors] = useState({});
const initialValues = {payment_id:params.id,gallery_name:'',booth_nickname:'',frame_color:'',frame_matting:'',wall_color1:'',wall_color2:'',wall_color3:'',wall_color4:''};
const [formValues, setFormValues] = useState(initialValues);
const [virtualList, setVirtualList] = React.useState([]);
const [opencolor1, setOpencolor1] = useState(false)
const [opencolor2, setOpencolor2] = useState(false)
const [opencolor3, setOpencolor3] = useState(false)
const [opencolor4, setOpencolor4] = useState(false)
const [virtualWall1Image, getVirtualWall1Image] = React.useState([]);
const [virtualWall2Image, getVirtualWall2Image] = React.useState([]);
const [virtualWall3Image, getVirtualWall3Image] = React.useState([]);
const [virtualWall4Image, getVirtualWall4Image] = React.useState([]);
const [color1, setColor1] = useColor("hex", "#fff");
const [color2, setColor2] = useColor("hex", "#fff");
const [color3, setColor3] = useColor("hex", "#fff");
const [color4, setColor4] = useColor("hex", "#fff");

const toggle = () => {
	setsidebar(!sidebar);
	setmainbar(!mainbar);
}

useEffect(() => {
	let paramsDt={payment_id:params.id}
	listArtworkByPayment(paramsDt).then(res => setHandleExhibitorResponse(res))
  },[]);

const setHandleExhibitorResponse = (response) => 
{
	if(response.data.code===200){  
		setVirtualList(response.data.data.item);
		if(response.data.data.item.length){
			setFormValues(prevState => ({
				...prevState,
				['gallery_name']:  response.data.data.item[0].gallery_name}));
		}
	}
}

const imageClick = (data,event) => {
	if(event===1){
		if(virtualWall1Image.includes(data.id)){
            getVirtualWall1Image(current =>
                current.filter(virtualWall1Image => {
                  return virtualWall1Image !== data.id;
                }),
            );
        } else {
            getVirtualWall1Image(current => [...current, data.id]);
        }
	} else if(event===2){
		if(virtualWall2Image.includes(data.id)){
            getVirtualWall2Image(current =>
                current.filter(virtualWall2Image => {
                  return virtualWall2Image !== data.id;
                }),
            );
        } else {
            getVirtualWall2Image(current => [...current, data.id]);
        }
	} else if(event===3){
		if(virtualWall3Image.includes(data.id)){
            getVirtualWall3Image(current =>
                current.filter(virtualWall3Image => {
                  return virtualWall3Image !== data.id;
                }),
            );
        } else {
            getVirtualWall3Image(current => [...current, data.id]);
        }
	} else if(event===4){
		if(virtualWall4Image.includes(data.id)){
            getVirtualWall4Image(current =>
                current.filter(virtualWall4Image => {
                  return virtualWall4Image !== data.id;
                }),
            );
        } else {
            getVirtualWall4Image(current => [...current, data.id]);
        }
	}
	
}

const colorhandleChange = (data) => {
	if(data===1) {
		setOpencolor1(prevOpencolor => !prevOpencolor);
	} else if(data===2) {
		setOpencolor2(prevOpencolor => !prevOpencolor);
	} else if(data===3) {
		setOpencolor3(prevOpencolor => !prevOpencolor);
	} else if(data===4) {
		setOpencolor4(prevOpencolor => !prevOpencolor);
	}
	
}


const handleChange = (e) => {
	const value=e.target.value;
	const field=e.target.name;
	setFormValues(prevState => ({
		...prevState,
		[field]:  value  }));
}

const handleSubmit = (e) => {
	e.preventDefault();
	formValues.wall_color1=color1.hex;
	formValues.wall_color2=color2.hex;
	formValues.wall_color3=color3.hex;
	formValues.wall_color4=color4.hex;
	const errorCount = validate(formValues);
	setFormErrors(errorCount);
	const errorCount1 = validateImage1(virtualWall1Image,virtualWall2Image,virtualWall3Image,virtualWall4Image);
	
	
	if(errorCount.status && errorCount1.status){
		
		const inputData={formData:JSON.stringify(formValues),imageData1:JSON.stringify(virtualWall1Image),imageData2:JSON.stringify(virtualWall2Image),imageData3:JSON.stringify(virtualWall3Image),imageData4:JSON.stringify(virtualWall4Image)}
		createVirtualBooth(inputData).then(res => handleResponse(res))
	}
}

const handleResponse = (response) => {
	if(response.data.code==200){
		Swal.fire({
			icon: 'success',
			text: 'Virtual Booth Added successfully',
		})
	} else {
		const errors = {};
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.message,
        })
	}  
  }

const validateImage1 = (values1,values2,values3,values4) => {
	const errorsDt = {};
	errorsDt.status = true;
	let imgval=1;
	let strcont='';
	if(values1.length===0){
		imgval=0;
		strcont+=1+', ';
	}
	if(values2.length===0){
		imgval=0;
		strcont+=2+', ';
	}
	if(values3.length===0){
		imgval=0;
		strcont+=3+', ';
	}
	if(values4.length===0){
		imgval=0;
		strcont+=4+',';
	}
	if(imgval===0){
		strcont = strcont.slice(0, -1); 
		Swal.fire({
			icon: 'error',
			title: 'Oops...',
			text: 'Please select atleast any one image from Wall '+strcont,
		})
		return false;
	} else {
		return errorsDt;
		return true;
	}
	
}

const validate = (values) => {
	const errors = {};
	errors.status = true;
	if(!values.gallery_name){
		errors.gallery_name = 'Gallery Name is required';
		errors.status = false;
	} 
	if(!values.booth_nickname){
		errors.booth_nickname = 'Booth Nickname is required';
		errors.status = false;
	}
	if(!values.frame_color){
		errors.frame_color = 'Frame Color is required';
		errors.status = false;
	}
	if(!values.frame_matting){
		errors.frame_matting = 'Frame Matting is required';
		errors.status = false;
	}
	if(!values.wall_color1){
		errors.wall_color1 = 'Wall1 Color is required';
		errors.status = false;
	}
	if(!values.wall_color2){
		errors.wall_color2 = 'Wall2 Color is required';
		errors.status = false;
	}
	if(!values.wall_color3){
		errors.wall_color3 = 'Wall3 Color is required';
		errors.status = false;
	}
	if(!values.wall_color4){
		errors.wall_color4 = 'Wall4 Color is required';
		errors.status = false;
	}
	return errors;
}


return(
<>
	<section className="sec-container" >
		<div className='container'>
			<div className='portalevent'>
				<div className='row'>
					<div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
						<div >
							<Rightbar/>
						</div>
					</div>
					<div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
						<div className='rightbar virtual-tab'>
							<Button variant="outline-info" onClick={toggle}>
							<FontAwesomeIcon icon={faAlignLeft} />
							</Button>
							<h1>CREATE VIRTUAL BOOTH</h1>

							<Form>
								<Form.Group className="mb-3" controlId="formBasicEmail">
									<Form.Label>Gallery Name</Form.Label>
									<Form.Control type="text" placeholder="Gallery Name" name="gallery_name" onChange={handleChange} value={formValues.gallery_name}/>
									<Form.Text className="text-muted">
										This is the gallery name that will appear in your booth.
									</Form.Text>
									<p className="error">{formErrors.gallery_name}</p>
								</Form.Group>
								<Form.Group className="mb-3" controlId="formBasicEmail">
									<Form.Label>Booth Nickname</Form.Label>
									<Form.Control type="text" placeholder="Booth Nickname" name="booth_nickname" onChange={handleChange}/>
									<p className="error">{formErrors.booth_nickname}</p>
								</Form.Group>
								<Form.Group className="mb-3" controlId="formBasicEmail">
									<Form.Label>Frame Color</Form.Label>
									<Form.Select aria-label="Default select example" name="frame_color" onChange={handleChange}>
										<option value="" >Select</option>
										<option value="black">Black</option>
										<option value="white">White</option>
										<option value="none">None</option>
									</Form.Select>
									<p className="error">{formErrors.frame_color}</p>
								</Form.Group>
								<Form.Group className="mb-3" controlId="formBasicEmail">
									<Form.Label>Frame Matting</Form.Label>
									<Form.Select aria-label="Default select example" name="frame_matting" onChange={handleChange}>
										<option value="" >Select</option>
										<option value="black">Black</option>
										<option value="white">White</option>
										<option value="none">None</option>
									</Form.Select>
									<p className="error">{formErrors.frame_matting}</p>
								</Form.Group>
							

								<Tabs defaultActiveKey="Wall 1" id="uncontrolled-tab-example">
									<Tab eventKey="Wall 1" title="Wall 1" >
										
										<Form.Group className="mb-3" controlId="formBasicEmail">
										<Form.Label>Wall Color</Form.Label>
										<Form.Control type="text" name="wall_color1" onClick = {(e) => colorhandleChange(1)} value={color1.hex} style={{backgroundColor : color1.hex, color : color1.hex}}/>
										</Form.Group>
										{
											opencolor1 ? (
												<div className="picker-box">
													<div className="picker-continer">
														<ColorPicker width={400} height={200}
														color={color1}
														onChange={setColor1} hideHSV hideRGB dark />
														<button onClick = {(e) => colorhandleChange(1)}  className="picker-close">OKAY</button>
													</div>
												</div>
											) : ''
										}
										<p className="error">{formErrors.wall_color1}</p>
										
									
										<Row xs={1} md={4} className="g-4 mb-3 virtual-tab" >
											{
												virtualList.length ?
												virtualList.map( data => (
												<Col>
													<Card style={{"textAlign" : "center"}} className={virtualWall1Image.includes(data.id) ? 'setbackground' :''}> 
														<Card.Body>
															<Card.Title>{data.image_name}</Card.Title>
														</Card.Body>
														<Form.Label htmlFor="wall1-image1" className="wall-image-lab" onClick = {(e) => imageClick(data,1)}>
														<Card.Img variant="top" src={ process.env.REACT_APP_PUBLIC_URL+data.images}/>
														</Form.Label>
													</Card>
												</Col>
												)) : ''
											}
										</Row>
									</Tab>
									<Tab eventKey="Wall 2" title="Wall 2">
										
									<Form.Group className="mb-3" controlId="formBasicEmail">
										<Form.Label>Wall Color</Form.Label>
										<Form.Control type="text" name="wall_color2" onClick = {(e) => colorhandleChange(2)} value={color2.hex} style={{backgroundColor : color2.hex, color : color2.hex}}/>
										</Form.Group>
										{
											opencolor2 ? (
												<div className="picker-box">
													<div className="picker-continer">
														<ColorPicker width={400} height={200}
														color={color2}
														onChange={setColor2} hideHSV hideRGB dark />
														<button onClick = {(e) => colorhandleChange(2)} className="picker-close">OKAY</button>
													</div>
												</div>
											) : ''
										}
										<p className="error">{formErrors.wall_color2}</p>
										
										<Row xs={1} md={4} className="g-4 mb-3" >
											{
												virtualList.length ?
												virtualList.map( data => (
												<Col>
													<Card style={{"textAlign" : "center"}} className={virtualWall2Image.includes(data.id) ? 'setbackground' :''}> 
														<Card.Body>
															<Card.Title>{data.image_name}</Card.Title>
														</Card.Body>
														<Form.Label htmlFor="wall1-image1" className="wall-image-lab" onClick = {(e) => imageClick(data,2)}>
														<Card.Img variant="top" src={ process.env.REACT_APP_PUBLIC_URL+data.images}/>
														</Form.Label>
													</Card>
												</Col>
												)) : ''
											}
										</Row>
									</Tab>
									<Tab eventKey="Wall 3" title="Wall 3">
										<Form.Group className="mb-3" controlId="formBasicEmail">
											<Form.Label>Wall Color</Form.Label>
											<Form.Control type="text" name="wall_color3" onClick = {(e) => colorhandleChange(3)} value={color3.hex} style={{backgroundColor : color3.hex, color : color3.hex}}/>
										</Form.Group>
										{
											opencolor3 ? (
												<div className="picker-box">
													<div className="picker-continer">
														<ColorPicker width={400} height={200}
														color={color3}
														onChange={setColor3} hideHSV hideRGB dark />
														<button onClick = {(e) => colorhandleChange(3)} className="picker-close">OKAY</button>
													</div>
												</div>
											) : ''
										}
										<p className="error">{formErrors.wall_color3}</p>
										
										<Row xs={1} md={4} className="g-4 mb-3" >
											{
												virtualList.length ?
												virtualList.map( data => (
												<Col>
													<Card style={{"textAlign" : "center"}} className={virtualWall3Image.includes(data.id) ? 'setbackground' :''}> 
														<Card.Body>
															<Card.Title>{data.image_name}</Card.Title>
														</Card.Body>
														<Form.Label htmlFor="wall1-image1" className="wall-image-lab" onClick = {(e) => imageClick(data,3)}>
														<Card.Img variant="top" src={ process.env.REACT_APP_PUBLIC_URL+data.images}/>
														</Form.Label>
													</Card>
												</Col>
												)) : ''
											}
										</Row>
									</Tab>
									<Tab eventKey="Wall 4" title="Wall 4">
										
										<Form.Group className="mb-3" controlId="formBasicEmail">
											<Form.Label>Wall Color</Form.Label>
											<Form.Control type="text" name="wall_color4" onClick = {(e) => colorhandleChange(4)} value={color4.hex} style={{backgroundColor : color4.hex, color : color4.hex}}/>
										</Form.Group>
										{
											opencolor4 ? (
												<div className="picker-box">
													<div className="picker-continer">
														<ColorPicker width={400} height={200}
														color={color4}
														onChange={setColor4} hideHSV hideRGB dark />
														<button onClick = {(e) => colorhandleChange(4)} className="picker-close">OKAY</button>
													</div>
												</div>
											) : ''
										}
										<p className="error">{formErrors.wall_color4}</p>
										
										<Row xs={1} md={4} className="g-4 mb-3" >
											{
												virtualList.length ?
												virtualList.map( data => (
												<Col>
													<Card style={{"textAlign" : "center"}} className={virtualWall4Image.includes(data.id) ? 'setbackground' :''}> 
														<Card.Body>
															<Card.Title>{data.image_name}</Card.Title>
														</Card.Body>
														<Form.Label htmlFor="wall1-image1" className="wall-image-lab" onClick = {(e) => imageClick(data,4)}>
														<Card.Img variant="top" src={ process.env.REACT_APP_PUBLIC_URL+data.images}/>
														</Form.Label>
													</Card>
												</Col>
												)) : ''
											}
										</Row>
									</Tab>
								</Tabs>
								<br/>
								<div className='text-center'>
									<Button className='common-btn' onClick={handleSubmit} >Save</Button>
								</div>
							</Form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>  
</>
)
}